module.exports = __webpack_public_path__ + "static/afterclimb_wireframe-2f8e0d2273920a66ebb1cd81e0318863.jpg";